import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LiberarLicencaEquipeComponent } from './liberar-licenca-equipe.component';
import { CardModule } from '../../../shared/components/card/card.module';
import { ContainerPadraoModule } from '../../../shared/components/container-padrao/container-padrao.module';
import { LookupModule } from '../../../shared/components/lookup/lookup.module';
import { ButtonModule } from '../../../shared/components/button/button.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@NgModule({
    declarations: [LiberarLicencaEquipeComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        CardModule,
        LookupModule,
        ButtonModule,
        ContainerPadraoModule
    ],
    exports: [LiberarLicencaEquipeComponent]
})
export class LiberarLicencaEquipeModule {}
